export default __webpack_public_path__ + "static/media/style-profile.2a3b2639.svg";